import { useGetETSTicketsQuery } from 'gcs-common/clients/api/entities/tickets/tickets-api';
import {
  convertETSTicketsFiltersToQuery,
  useETSTicketsQueryParams,
} from 'gcs-common/clients/api/entities/tickets/tickets-api-helpers';
import IconComponent from 'gcs-common/components/Icon/Icon';
import { ICON, ICON_SIZE } from 'gcs-common/constants/IconConstants';
import { TICKET_DASHBOARD_TABS, TicketDashboardTabNames } from 'gcs-common/slices/tickets/ticketsConstants';
import type { Entries } from 'type-fest';
import styles from './styles.module.scss';

const StatusFilter = () => {
  const { etsTicketsfilters: filters, setETSTicketsQueryParams } = useETSTicketsQueryParams();
  const { data } = useGetETSTicketsQuery({
    query: convertETSTicketsFiltersToQuery(filters),
  });
  const ticketCounts = data ? data.status : undefined;
  const activeTab = filters.tab || '';

  const total = ticketCounts ? Object.values(ticketCounts).reduce((a: number, c: number) => a + c, 0) : 0;

  const setTab = (tab?: TicketDashboardTabNames) => {
    setETSTicketsQueryParams({
      creatorId: tab === TicketDashboardTabNames.NOT_LISTED ? 'None' : filters.creatorId,
      tab,
    });
  };

  return (
    <>
      {ticketCounts ? (
        <div className={styles.statusFilterContainer}>
          <button
            className={`${styles.statusTab} ${activeTab === '' ? styles.activeTab : ''}`}
            onClick={() => setTab(undefined)}
            type="button"
          >
            Alle
            <span className={styles.ticketCount}>({total})</span>
          </button>
          {(Object.entries(TICKET_DASHBOARD_TABS) as Entries<typeof TICKET_DASHBOARD_TABS>).map(([key]) => {
            const entry = TICKET_DASHBOARD_TABS[key];
            if (!entry) return null;
            const { title } = entry;
            return (
              <button
                key={key}
                className={`${styles.statusTab} ${activeTab === key ? styles.activeTab : ''}`}
                onClick={() => setTab(key)}
                type="button"
              >
                <div className="flex items-center gap-2">
                  <div>{title}</div>
                  <div className={styles.ticketCount}>({ticketCounts[key]})</div>
                </div>
              </button>
            );
          })}
        </div>
      ) : (
        <IconComponent Icon={ICON.LOADING_DOTS} size={ICON_SIZE.X_LARGE} />
      )}
    </>
  );
};

export default StatusFilter;
